import { useState } from 'react';
import { message } from 'antd';
import { CollectFormTemplateAPIs } from '../../../common/typescript/apis/CollectFormTemplateAPIs';

export const useSqliteUpload = (templateUuid: string | null) => {
  const [uploading, setUploading] = useState(false);

  const uploadSqlite = async (file: File): Promise<{ objectName: string }> => {
    if (!templateUuid) {
      throw new Error('Template UUID is required');
    }

    try {
      setUploading(true);
      const response = await CollectFormTemplateAPIs.remote_uploadSqlite(templateUuid, file);
      return { objectName: response.data.objectName };
    } catch (error) {
      console.error('[useSqliteUpload] Upload failed:', error);
      throw error;
    } finally {
      setUploading(false);
    }
  };

  return {
    uploadSqlite,
    uploading,
  };
};
